export default function RunningCourseIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 7.55499C16.1385 5.88227 13.1013 4.99539 10 4.99999C8.15498 4.9981 6.32316 5.31092 4.58333 5.92499C4.33965 6.01114 4.12867 6.17071 3.97943 6.38174C3.83019 6.59276 3.75004 6.84486 3.75 7.10332V30.8533C3.75003 31.0533 3.79803 31.2503 3.88997 31.4279C3.98191 31.6055 4.11511 31.7584 4.27838 31.8738C4.44166 31.9893 4.63025 32.0638 4.82831 32.0913C5.02638 32.1188 5.22814 32.0983 5.41667 32.0317C6.88889 31.5124 8.43889 31.2481 10 31.25C13.325 31.25 16.3717 32.4283 18.75 34.3933V7.55499ZM21.25 34.3933C23.7107 32.3569 26.806 31.2449 30 31.25C31.61 31.25 33.15 31.5267 34.5833 32.0333C34.772 32.1 34.9739 32.1205 35.1721 32.0929C35.3703 32.0654 35.559 31.9906 35.7223 31.875C35.8856 31.7594 36.0188 31.6062 36.1106 31.4284C36.2024 31.2507 36.2502 31.0534 36.25 30.8533V7.10332C36.25 6.84486 36.1698 6.59276 36.0206 6.38174C35.8713 6.17071 35.6603 6.01114 35.4167 5.92499C33.6768 5.31092 31.845 4.9981 30 4.99999C26.8987 4.99539 23.8615 5.88227 21.25 7.55499V34.3933Z"
        fill="#F54C64"
      />
    </svg>
  );
}
